module.exports = __webpack_public_path__ + "img/5.c3538d90.jpeg";